import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Form,
  PhoneNumberInput,
  PLATFORM_THEME_COLORS,
  SelectInput,
  TextInput,
} from '@thinknet-gmbh/platform-common-ui';

import { MaritalStatusesEnum, DEFAULT_NAME_FIELD_REGEX } from '@thinknet-gmbh/platform-common';

import { generateStepArray } from 'src/common/helpers/common.helpers';

import { BooleanSelectInput } from 'src/pages/employee/components/boolean-select-input';

import { EmergencyContainer } from '../../personal-info.styles';
import { StyledContainer, TitleRowLabel } from '../../../employee-common.styles';

const EmergencyData = ({ isOwnData }: { isOwnData?: boolean }) => {
  const { t } = useTranslation('employee');

  const steps = generateStepArray(0, 10, 0.5);

  return (
    <Fragment>
      <StyledContainer>
        <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
          {t('employee:labels.emergencyContactDetails')}
        </TitleRowLabel>
        <EmergencyContainer>
          <Form.Item
            name={['emergencyContact', 'name']}
            label={t('emergencyDetails.labels.emergencyName')}
            rules={[
              { required: true, message: t('emergencyDetails.validation.emergencyNameRequired') },
              {
                pattern: DEFAULT_NAME_FIELD_REGEX,
                message: t('common:validation.error.incorrectFormat'),
              },
            ]}
          >
            <TextInput maxLength={50} placeholder={t('emergencyDetails.placeholders.emergencyName')} />
          </Form.Item>
          <Form.Item
            name={['emergencyContact', 'phoneNumber']}
            label={t('emergencyDetails.labels.emergencyPhoneNumber')}
            rules={[
              {
                required: true,
                message: t('emergencyDetails.validation.emergencyPhoneNumberRequired'),
              },
            ]}
          >
            <PhoneNumberInput placeholder="+49 176 384 15749" />
          </Form.Item>
          <Form.Item
            name={['emergencyContact', 'relationship']}
            label={t('emergencyDetails.labels.emergencyRelationship')}
            rules={[
              {
                required: true,
                message: t('emergencyDetails.validation.emergencyContactRequired'),
              },
            ]}
          >
            <TextInput maxLength={50} placeholder={t('emergencyDetails.placeholders.emergencyRelationship')} />
          </Form.Item>

          <Form.Item
            name={['emergencyContact', 'firstAider']}
            label={t('emergencyDetails.labels.firstAider')}
          >
            <BooleanSelectInput disabled={isOwnData} t={t} />
          </Form.Item>
        </EmergencyContainer>
      </StyledContainer>
      <StyledContainer>
        <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
          {t('employee:labels.familyStatus')}
        </TitleRowLabel>
        <EmergencyContainer>
          <Form.Item
            name={['emergencyContact', 'maritalStatus']}
            label={t('emergencyDetails.labels.maritalStatus')}
          >
            <SelectInput disabled={isOwnData} placeholder={t('emergencyDetails.labels.married')}>
              {Object.keys(MaritalStatusesEnum).map(status => (
                <SelectInput.Option key={status} value={status}>
                  {t(`emergencyDetails.labels.${status.toLowerCase()}`)}
                </SelectInput.Option>
              ))}
            </SelectInput>
          </Form.Item>
          <Form.Item
            name={['emergencyContact', 'childAllowance']}
            label={t('emergencyDetails.labels.childAllowance')}
          >
            <SelectInput disabled={isOwnData} placeholder={1}>
              {steps.map(el => (
                <SelectInput.Option key={el} value={el}>
                  {el}
                </SelectInput.Option>
              ))}
            </SelectInput>
          </Form.Item>
        </EmergencyContainer>
      </StyledContainer>
    </Fragment>
  );
};

export default EmergencyData;
